import React, { FC } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { QuickAdd } from "./QuickAddHelper";
import { px } from "Configs/theme";
import {
	getColorRgbaFromHex,
	getTextColorFromBackgroundColor,
} from "Helpers/ColorHelper";
import { v4 } from "uuid";
import { useDrag } from "react-dnd";
import { CALENDAR_ENTRY_HEIGHT } from "Components/Calendar/CalendarEntryHelper";
import { CellSize } from "Components/Calendar/CalendarHelper";
import { DraggedItem } from "Components/DropArea/types/DraggedItem";

interface Props {
	quickAdd: QuickAdd;
	cellSize: CellSize;
}

const QuickAddView: FC<Props> = (props) => {
	const classes = useStyles({
		colorHex: props.quickAdd.colorHex,
		isProject: !!props.quickAdd.projectId,
		cellWidth: props.cellSize.week.dayWidth,
	});

	const draggedItem: DraggedItem = {
		type: props.quickAdd.typeId || "project",
		colorHex: props.quickAdd.colorHex,
		isAddingNew: true,
		calendarEntry: {
			id: v4(),
			startTime: 0,
			endTime: 0,
			projectId: props.quickAdd.projectId,
			typeId: props.quickAdd.typeId,
		},
	};

	const [, drag] = useDrag({
		item: draggedItem,
		options: {
			dropEffect: "move",
		},
	});

	function renderIcon() {
		if (props.quickAdd.icon) {
			return <Box className={classes.icon}>{props.quickAdd.icon}</Box>;
		}
	}

	return (
		<div ref={drag} className={classes.quickAdd}>
			{renderIcon()}
			{props.quickAdd.name}
		</div>
	);
};

export default QuickAddView;

interface StyleProps {
	colorHex: string;
	isProject: boolean;
	cellWidth: number;
}

const useStyles = makeStyles({
	quickAdd: (props: StyleProps) => ({
		height: CALENDAR_ENTRY_HEIGHT,
		marginRight: px.s,
		padding: `${px.none} ${px.s}`,
		cursor: "move",
		userSelect: "none",
		touchCallout: "none",
		display: "flex",
		alignItems: "center",
		boxSizing: "border-box",
		borderRadius: px.xs,
		backgroundColor: props.isProject
			? getColorRgbaFromHex(props.colorHex, 0.1)
			: props.colorHex,
		border: `1px solid ${props.colorHex}`,
		fontSize: "10px",
		fontWeight: "bold",
		color: getTextColorFromBackgroundColor(props.colorHex, !props.isProject),
		overflow: "hidden",
		whiteSpace: "nowrap",
		width: props.cellWidth,
	}),
	icon: {
		display: "flex",
		marginRight: px.xs,
	},
});
